<template>
  <div class="club-page">
    <div class="tab-box">
      <ul class="tab-btn-list">
        <li v-for="(tab, index) in tabList" :key="index" :class="{active:currentTab === index}"
            @click="tabIndexChange(currentTab)">
          <a href="#" @click.prevent="currentTab = index">{{ tab }}</a>
        </li>
      </ul>
    </div>

    <div v-if="currentTab === 0" class="tab-content">
      <HistoryMuseum />
    </div>
    <div v-if="currentTab === 1" class="tab-content">
      <Record />
    </div>
    <div v-if="currentTab === 2" class="tab-content">
      <FormerDirector />
    </div>
    <div v-if="currentTab === 3" class="tab-content">
      <FormerLeader />
    </div>
  </div>
</template>
<script>
import HistoryMuseum from '@/components/Club/HistoryMuseum.vue';
import Record from '@/components/Club/Record.vue';
import FormerDirector from '@/components/Club/FormerDirector.vue';
import FormerLeader from '@/components/Club/FormerLeader.vue';

export default {
  name: 'HistoryView',
  components: {FormerLeader, FormerDirector, Record, HistoryMuseum},
  data() {
    return {
      currentTab: 0,
      tabList: ['역사관', '기록실', '역대 감독', '역대 주장'],
    }
  },
  mounted () {
  },
  methods: {
    tabIndexChange(val) {
    },
  }
}
</script>
<style scoped>
.tab-box .tab-btn-list li {
  padding: 0;
  height: 56px;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-wrap: wrap;
}
</style>
